import AccountCircle from "@mui/icons-material/AccountCircle";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import BallotIcon from "@mui/icons-material/Ballot";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import HomeIcon from "@mui/icons-material/Home";
import {
  ListItemButton,
  Divider,
  BottomNavigation,
  Box,
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  BottomNavigationAction,
  Button,
  Paper,
  Grid,
} from "@mui/material";
import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import CrescendoForm from "../pages/forms/crescendoForm";
import ReefscapeForm from "../pages/forms/reefscapeForm";
import DataCollector from "./datacollector";
import iconImage from "../images/torch.png";
import MenuIcon from "@mui/icons-material/Menu";
import Home from "./home";
import Analysis from "./analysis/analysis";
import Leaderboard from "./leaderboard";
import Account from "./account";
import Scouting from "./scouting";
import DataDashboard from "./dataDisplay";
import { getUser } from "../api/user";
import PendingPage from "./pendingPage";
import EventAnalysisByYear from "./analysis/eventAnalysisByYear";
import TeamAnalysisByYear from "./analysis/teamAnalysisByYear";
import TeamAnalysisByEvent from "./analysis/teamAnalysisByEvent";
import MatchAnalysisByEvent from "./analysis/matchAnalysisByEvent";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useGlobal } from "../context/GlobalProvider";

const DiscordIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
  </SvgIcon>
);

async function GetAllianceData() {
  const data = await fetch(`/api/blueAlliance`);
  let parsed = data.json();
  return parsed;
}

async function GetUser(id) {
  const data = await getUser(id);
  const body = JSON.parse(data.body);
  return body;
}

export default function Dashboard({ signOut, user }) {
  const { currentTab, setCurrentTab } = useGlobal();
  const [auth, setAuth] = React.useState(true);
  const [anchorElComputer, setAnchorElComputer] = React.useState(null);
  const [anchorElMobile, setAnchorElMobile] = React.useState(null);
  const [menuIndex, setMenuIndex] = React.useState(1);
  const [dbUser, setDbUser] = React.useState({});

  useEffect(() => {
    const fetchData = async () => {
      const result = await GetAllianceData();
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const result = await GetUser(user.userId);
      let data = result?.data?.length > 0 ? result?.data[0] : [];
      setDbUser(data);
    };
    if (user) {
      fetchData();
    }
  }, [user]);

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleComputerMenu = (event) => {
    setAnchorElComputer(event.currentTarget);
  };

  const handleMobileMenu = (event) => {
    setAnchorElMobile(event.currentTarget);
  };

  const handleComputerClose = () => {
    setAnchorElComputer(null);
  };
  const handleMobileClose = () => {
    setAnchorElMobile(null);
  };

  const [mobileScoutingOpen, setMobileScoutingOpen] = useState(false);
  const paperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (paperRef.current && !paperRef.current.contains(event.target)) {
        setMobileScoutingOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();
  const handleBottomNavChange = (event, newValue) => {
    if (newValue != "scouting") {
      navigate(`/${newValue}`);
      setCurrentTab(newValue);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          display: { xs: "none", sm: "flex" },
          flexDirection: "row",
        }}
      >
        {dbUser?.is_pending === 0 && (
          <Toolbar
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "appbar.background",
            }}
          >
            <Box
              sx={{
                display: "contents",
                alignItems: "center",
                gap: 2,
              }}
            >
              <img
                src={iconImage}
                alt="Ignite Insight"
                style={{
                  width: 30,
                  height: 30,
                  zIndex: "999",
                  marginRight: 5,
                }}
              />
              <Typography
                variant="h6"
                component="div"
                sx={{
                  marginRight: 1,
                  color: "appbar.text",
                  fontWeight: "bold",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Ignite Insights
              </Typography>
              <Link to={"home"} style={{ textDecoration: "none" }}>
                <ListItemButton
                  onClick={() => setCurrentTab("home")}
                  sx={{
                    paddingTop: 1,
                    paddingBottom: 1,
                    margin: 0.3,
                    flexGrow: "1",
                    backgroundColor:
                      currentTab === "home" ? "background.main" : "transparent",
                    border: currentTab === "home" ? "2px solid" : "",
                    borderColor: "appbar.text",
                    borderRadius: 3,
                    color: "appbar.text",
                    "&:hover": {
                      backgroundColor:
                        currentTab === "home"
                          ? "background.dark"
                          : "transparent",
                    },
                  }}
                >
                  <Typography component="div" style={{ fontSize: 15 }}>
                    <b>Home</b>
                  </Typography>
                </ListItemButton>
              </Link>
              <Link to={`analysis`} style={{ textDecoration: "none" }}>
                <ListItemButton
                  onClick={() => setCurrentTab("analysis")}
                  sx={{
                    paddingTop: 1,
                    paddingBottom: 1,
                    margin: 0.3,
                    flexGrow: "1",
                    backgroundColor:
                      currentTab === "analysis"
                        ? "background.main"
                        : "transparent",
                    border: currentTab === "analysis" ? "2px solid" : "",
                    borderColor: "appbar.text",
                    borderRadius: 3,
                    color: "appbar.text",
                    "&:hover": {
                      backgroundColor:
                        currentTab === "analysis"
                          ? "background.dark"
                          : "transparent",
                    },
                  }}
                >
                  <Typography component="div" style={{ fontSize: 15 }}>
                    <b>Analysis</b>
                  </Typography>
                </ListItemButton>
              </Link>
              <Link to={"leaderboard"} style={{ textDecoration: "none" }}>
                <ListItemButton
                  onClick={() => setCurrentTab("leaderboard")}
                  sx={{
                    paddingTop: 1,
                    paddingBottom: 1,
                    margin: 0.3,
                    flexGrow: "1",
                    backgroundColor:
                      currentTab === "leaderboard"
                        ? "background.main"
                        : "transparent",
                    border: currentTab === "leaderboard" ? "2px solid" : "",
                    borderColor: "appbar.text",
                    borderRadius: 3,
                    color: "appbar.text",
                    "&:hover": {
                      backgroundColor:
                        currentTab === "leaderboard"
                          ? "background.dark"
                          : "transparent",
                    },
                  }}
                >
                  <Typography component="div" style={{ fontSize: 15 }}>
                    <b>Leaderboard</b>
                  </Typography>
                </ListItemButton>
              </Link>
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: "1" }}
              ></Typography>

              <Link
                to={"datacollector/reefscape"}
                style={{ textDecoration: "none" }}
              >
                <ListItemButton
                  onClick={() => setCurrentTab("scouting")}
                  sx={{
                    paddingTop: 1,
                    paddingBottom: 1,
                    margin: 0.3,
                    backgroundColor: "background.main",
                    border: "2px solid",
                    borderColor: "appbar.text",
                    borderRadius: 3,
                    color: "appbar.text",
                    textAlign: "center",
                    "&:hover": {
                      backgroundColor:
                        currentTab === "scouting"
                          ? "background.main"
                          : "background.dark",
                    },
                  }}
                >
                  <Typography component="div" style={{ fontSize: 15 }}>
                    <b>Collect Data</b>
                  </Typography>
                </ListItemButton>
              </Link>
              <IconButton
                size="large"
                aria-label="discord"
                aria-controls="discord"
                aria-haspopup="true"
                onClick={() => window.open("http://discord.gg/Cbv5k5Xt36")}
                sx={{ color: "appbar.text" }}
              >
                <DiscordIcon />
              </IconButton>
              {auth && (
                <div>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleComputerMenu}
                    sx={{ color: "appbar.text" }}
                  >
                    <AccountCircle />
                  </IconButton>
                  <Menu
                    id="computerIcon"
                    anchorEl={anchorElComputer}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElComputer)}
                    onClose={handleComputerClose}
                    PaperProps={{
                      sx: {
                        backgroundColor: "background.main",
                        color: "appbar.text",
                      },
                    }}
                  >
                    <Link to={"scouting"} style={{ textDecoration: "none" }}>
                      <MenuItem
                        sx={{ color: "appbar.text" }}
                        onClick={handleMobileClose}
                      >
                        Pit Scouting
                      </MenuItem>
                    </Link>
                    <Divider sx={{ color: "appbar.text" }} />
                    <Link
                      to={"account"}
                      style={{ color: "appbar.text", textDecoration: "none" }}
                    >
                      <MenuItem
                        sx={{ color: "appbar.text" }}
                        onClick={handleComputerClose}
                      >
                        My Account
                      </MenuItem>
                    </Link>
                    <MenuItem sx={{ color: "appbar.text" }} onClick={signOut}>
                      Sign Out
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </Box>
          </Toolbar>
        )}
      </AppBar>
      <Box
        sx={{
          width: { xs: "95%", md: "90%", xl: "80%" },
          bgcolor: "background.light",
          alignItems: "top",
          justifyContent: "center",
          justifySelf: "center",
          borderRadius: 4,
          p: { xs: 1, sm: 2, md: 3 },
          mt: 2,
          mb: { xs: "10vh", sm: 2 },
        }}
      >
        <Box>
          {dbUser?.is_pending === 0 && (
            <Routes>
              <Route
                path="/"
                element={<Home user={dbUser} signOut={signOut} />}
              />
              <Route path="table" element={<DataDashboard />} />
              <Route
                path="home"
                element={<Home user={dbUser} signOut={signOut} />}
              />
              <Route
                path="analysis"
                element={<Analysis user={dbUser} signOut={signOut} />}
              />
              <Route
                path="analysis/team/:teamNumber"
                element={<TeamAnalysisByYear />}
              />
              <Route
                path="analysis/event/:eventCode"
                element={<EventAnalysisByYear />}
              />
              <Route
                path="analysis/event/:eventCode/team/:teamNumber"
                element={
                  <TeamAnalysisByEvent user={dbUser} signOut={signOut} />
                }
              />
              <Route
                path="analysis/event/:eventCode/match/:matchNumber"
                element={<MatchAnalysisByEvent />}
              />
              <Route
                path="leaderboard"
                element={<Leaderboard user={dbUser} signOut={signOut} />}
              />
              <Route
                path="scouting"
                element={<Scouting user={dbUser} signOut={signOut} />}
              />
              <Route
                path="/datacollector"
                element={<DataCollector user={dbUser} />}
              >
                <Route
                  path="reefscape"
                  element={
                    <>
                      <ReefscapeForm user={dbUser} />
                    </>
                  }
                />
                <Route
                  path="crescendo"
                  element={
                    <>
                      <CrescendoForm />
                    </>
                  }
                />
              </Route>
              <Route
                path="account"
                element={<Account user={dbUser} signOut={signOut} />}
              />
            </Routes>
          )}
          {dbUser?.is_pending === 1 && (
            <Routes>
              <Route path="*" element={<PendingPage user={dbUser} />} />
            </Routes>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          px: 10,
          backgroundColor: "appbar.background",
          display: { xs: "flex", sm: "none" },
          flexDirection: "row",
          justifyContent: "center",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "8vh",
          zIndex: 1000,
        }}
      >
        <BottomNavigation
          value={currentTab}
          onChange={handleBottomNavChange}
          sx={{
            backgroundColor: "transparent",
            width: "100%",
            height: "8vh",
            margin: "auto",
            borderRadius: "12px",
          }}
        >
          <BottomNavigationAction
            label="Home"
            value="home"
            icon={<HomeIcon sx={{ fontSize: "3vh" }} />}
            sx={{ minWidth: "19vw", color: "appbar.text" }}
          />
          <BottomNavigationAction
            label="Analysis"
            value="analysis"
            icon={<LocalFireDepartmentIcon sx={{ fontSize: "3vh" }} />}
            sx={{ minWidth: "19vw", color: "appbar.text" }}
          />

          <BottomNavigationAction
            label="Scouting"
            value="scouting"
            icon={<BallotIcon sx={{ fontSize: "3vh" }} />}
            sx={{ minWidth: "19vw", color: "appbar.text" }}
            onClick={() => setMobileScoutingOpen(true)}
          />
          <BottomNavigationAction
            label="Leaderboard"
            value="leaderboard"
            icon={<EmojiEventsIcon sx={{ fontSize: "3vh" }} />}
            sx={{ minWidth: "19vw", color: "appbar.text" }}
          />
          <BottomNavigationAction
            label="Account"
            value="account"
            icon={<AccountCircle sx={{ fontSize: "3vh" }} />}
            sx={{ minWidth: "19vw", color: "appbar.text" }}
          />
        </BottomNavigation>
        {mobileScoutingOpen && (
          <Paper
            ref={paperRef}
            sx={{
              borderRadius: 10,
              position: "absolute",
              bottom: "90px", // Position above the button
              left: "50%",
              transform: "translateX(-50%)",
              width: "80%",
              zIndex: 10,
              aspectRatio: "5/1",
            }}
          >
            <Grid container sx={{ width: "100%", height: "100%" }}>
              <Grid
                item
                xs={6}
                sx={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 1,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ borderRadius: 10, width: "100%", height: "100%" }}
                  onClick={() => {
                    navigate(`/datacollector/reefscape`);
                    setCurrentTab("scouting");
                    setMobileScoutingOpen(false);
                  }}
                >
                  <b>Match</b>
                </Button>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 1,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ borderRadius: 10, width: "100%", height: "100%" }}
                  onClick={() => {
                    navigate(`/scouting`);
                    setCurrentTab("scouting");
                    setMobileScoutingOpen(false);
                  }}
                >
                  <b>Pit</b>
                </Button>
              </Grid>
            </Grid>
          </Paper>
        )}
      </Box>
    </Box>
  );
}
